import { PODCAST_AD_TYPES } from './constants';
import { CarouselActionProps, CarouselStateProps } from './types';
import { setUpSlideIndexRotation, setUpStartingSlideIndexArray } from './utils';

export const initialState: CarouselStateProps = {
  activeAdIndex: 0,
  activeSlide: PODCAST_AD_TYPES[0],
  isRotating: false,
  nextActiveAdIndex: 0,
  rotatingAdIndex: -1,
  slideIndexArray: setUpStartingSlideIndexArray(),
};

export const reducer = (
  state: CarouselStateProps,
  action: CarouselActionProps
): CarouselStateProps => {
  switch (action.type) {
    case 'Update Next Active Ad Index':
      return { ...state, nextActiveAdIndex: action.value || 0 };
    case 'Rotate Slide Index Array':
      return setUpSlideIndexRotation(state);
    default:
      return state;
  }
};
